module.exports = __webpack_public_path__ + "img/b1.eef2172a.webp";